var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalIncome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11706",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11707",
    d: "M6 21H4a1 1 0 01-1-1v-6a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1z",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11708",
    d: "M13 17h2.333a2 2 0 001.2-.4l2.416-1.812a1.515 1.515 0 011.98.141h0a1.514 1.514 0 010 2.142l-2.073 2.073a4 4 0 01-2.044 1.094l-2.93.586a4 4 0 01-1.755-.042l-2.65-.662a3.957 3.957 0 00-.969-.12H7",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11709",
    d: "M13 17h1.485A1.515 1.515 0 0016 15.485v-.3a1.514 1.514 0 00-1.147-1.469l-2.292-.573A4.705 4.705 0 0011.422 13h0a4.69 4.69 0 00-2.605.789L7 15",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11710",
    d: "M17.169 5.155a2.838 2.838 0 11-4.014 0 2.838 2.838 0 014.014 0",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11711",
    d: "M14.631 4.375a2.834 2.834 0 10-2.263 3.249",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgTotalIncome;


//////////////////
// WEBPACK FOOTER
// ./src/icons/totalIncome.svg
// module id = 901
// module chunks = 101